// extracted by mini-css-extract-plugin
export default {"socialIcons":"ShareComponent_socialIcons__bC7gk","shareText":"ShareComponent_shareText__FRjSK"};